import axiosInstance from "../../lib/axios";

//promocode dropdown
export async function getMstPromoCodedrp(payload) {
  try {
    return await axiosInstance.post("MstPromoCode/getMstPromoCodedrp",payload);
  } catch (error) {
    return error;
  }
}

export async function insertMstPromoCodeCoupon(payload){
    try{
        return await axiosInstance.post('MstPromoCodeCoupon/InsertMstPromoCodeCoupon',payload)
    }catch(error){
        return error;
    }
}

export async function updateMstPromoCodeCoupon(payload){
    try{
        return await axiosInstance.post('MstPromoCodeCoupon/UpdateMstPromoCodeCoupon',payload)
    }catch(error){
        return error;
    }
}

export async function retriveMstPromoCodeCoupon(payload){
  try{
   return await  axiosInstance.post('MstPromoCodeCoupon/RetriveMstPromoCodeCoupon',payload)
  }catch(error){
    return error;
  }
}


export async function getMstPromoCodeAuthdrp(){
  try{
   return await  axiosInstance.post('MstPromoCodeAuth/getMstPromoCodeAuthdrp')
  }catch(error){
    return error;
  }
}
